import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

const TEMAS_PADRAO = [
  "Limpeza e desinfecção hospitalar",
  "Lavanderia",
  "Higiene de mãos",
  "Produtos químicos e segurança",
];

function hojeIso() {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

function dataBR(iso) { if (!iso) return ""; const [y, m, d] = iso.split("-"); return `${d}/${m}/${y}`; }

export default function CanalClienteFicha({ cliente, slot = "both" }) {
  const [openForm, setOpenForm] = useState(false);
  const [tema, setTema] = useState(TEMAS_PADRAO[0]);
  const [temaOutro, setTemaOutro] = useState("");
  const [dataTrein, setDataTrein] = useState(hojeIso());
  const [carregando, setCarregando] = useState(false);

  const [openQR, setOpenQR] = useState(false);
  const [token, setToken] = useState("");
  const [qrUrl, setQrUrl] = useState("");
  const [copiado, setCopiado] = useState(false);

  const [resumo, setResumo] = useState(null);
  const [respostasAbertas, setRespostasAbertas] = useState({});

  const publicLink = token ? `${window.location.origin}/q/${token}` : "";

  const carregarResumo = async () => {
    if (!cliente?.id) return;
    try {
      const { data } = await api.get(`/canal-cliente/clientes/${cliente.id}/avaliacoes`);
      setResumo(data);
    } catch { /* silencia — seção vazia */ }
  };

  useEffect(() => { carregarResumo(); }, [cliente?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const abrirFormulario = () => {
    setTema(TEMAS_PADRAO[0]);
    setTemaOutro("");
    setDataTrein(hojeIso());
    setOpenForm(true);
  };

  const confirmarGerarQR = async () => {
    if (!cliente?.id) return;
    const temaFinal = tema === "Outro" ? temaOutro.trim() : tema;
    if (!temaFinal) { toast.error("Informe o tema"); return; }
    if (!dataTrein) { toast.error("Informe a data"); return; }
    setCarregando(true);
    try {
      const { data } = await api.post("/canal-cliente/treinamentos-aplicados", {
        cliente_id: cliente.id, tema, tema_outro: tema === "Outro" ? temaOutro : undefined, data: dataTrein,
      });
      const tok = data.token;
      setToken(tok);
      const url = `${window.location.origin}/q/${tok}`;
      const imgResp = await api.get("/canal-cliente/qr.png", { params: { token: tok, url, size: 1024 }, responseType: "blob" });
      setQrUrl(URL.createObjectURL(imgResp.data));
      setOpenForm(false);
      setOpenQR(true);
      carregarResumo();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Não foi possível gerar o QR");
    } finally { setCarregando(false); }
  };

  const copiarLink = async () => {
    try { await navigator.clipboard.writeText(publicLink); setCopiado(true); setTimeout(() => setCopiado(false), 1500); }
    catch { toast.error("Não foi possível copiar"); }
  };
  const baixarPng = () => {
    if (!qrUrl) return;
    const a = document.createElement("a");
    a.href = qrUrl; a.download = `qr-mpires-${cliente?.id || "cliente"}.png`;
    document.body.appendChild(a); a.click(); a.remove();
  };

  const toggleRespostas = async (apid) => {
    if (respostasAbertas[apid]) {
      setRespostasAbertas((p) => ({ ...p, [apid]: null }));
      return;
    }
    try {
      const { data } = await api.get(`/canal-cliente/treinamentos-aplicados/${apid}/respostas`);
      setRespostasAbertas((p) => ({ ...p, [apid]: data?.respostas || [] }));
    } catch {
      toast.error("Não foi possível carregar as respostas");
    }
  };

  const temResumo = resumo && ((resumo.aplicacoes?.length || 0) > 0 || (resumo.legado?.length || 0) > 0);
  const mostrarBotao = slot === "button" || slot === "both";
  const mostrarSecao = slot === "section" || slot === "both";

  return (
    <>
      {mostrarBotao && (
        <button type="button" onClick={abrirFormulario} disabled={carregando}
          data-testid="btn-qr-avaliacao-treinamento"
          className="w-full md:w-auto flex items-center justify-center h-14 md:h-[38px] md:px-4 rounded-lg bg-white border border-[#D5DEE5] text-navy text-[11px] md:text-sm font-semibold hover:bg-slate-50 transition-colors">
          <span className="leading-tight">QR de avaliação de treinamento</span>
        </button>
      )}

      {mostrarBotao && (
        <Dialog open={openForm} onOpenChange={setOpenForm}>
          <DialogContent className="max-w-md" data-testid="dialog-form-aplicacao">
            <DialogHeader><DialogTitle>Novo treinamento aplicado</DialogTitle></DialogHeader>
            <div className="space-y-3 py-2">
              <div>
                <label className="block text-sm font-semibold text-navy mb-1">Tema do treinamento</label>
                <select className="w-full h-10 px-3 rounded-lg border border-[#CFD8DF] text-sm" value={tema} onChange={(e) => setTema(e.target.value)} data-testid="form-aplicacao-tema">
                  {TEMAS_PADRAO.map((t) => <option key={t}>{t}</option>)}
                  <option value="Outro">Outro</option>
                </select>
              </div>
              {tema === "Outro" && (
                <div>
                  <label className="block text-sm font-semibold text-navy mb-1">Qual?</label>
                  <input className="w-full h-10 px-3 rounded-lg border border-[#CFD8DF] text-sm" value={temaOutro} onChange={(e) => setTemaOutro(e.target.value)} data-testid="form-aplicacao-tema-outro" />
                </div>
              )}
              <div>
                <label className="block text-sm font-semibold text-navy mb-1">Data do treinamento</label>
                <input type="date" className="w-full h-10 px-3 rounded-lg border border-[#CFD8DF] text-sm" value={dataTrein} onChange={(e) => setDataTrein(e.target.value)} data-testid="form-aplicacao-data" />
                <p className="text-xs text-slate-500 mt-1">O QR aceita respostas até 7 dias após essa data.</p>
              </div>
              <button onClick={confirmarGerarQR} disabled={carregando} data-testid="btn-form-aplicacao-confirmar"
                className="w-full h-11 rounded-lg bg-brand text-white text-sm font-semibold hover:bg-brand-hover disabled:opacity-60">
                {carregando ? "Gerando…" : "Gerar QR"}
              </button>
            </div>
          </DialogContent>
        </Dialog>
      )}

      {mostrarBotao && (
        <Dialog open={openQR} onOpenChange={setOpenQR}>
          <DialogContent className="max-w-md" data-testid="dialog-qr-avaliacao">
            <DialogHeader><DialogTitle>QR de avaliação de treinamento</DialogTitle></DialogHeader>
            <div className="flex flex-col items-center gap-4 py-2">
              {qrUrl && <img src={qrUrl} alt="QR Code" style={{ width: 260, height: 260, borderRadius: 8 }} data-testid="img-qr-avaliacao" />}
              <div className="w-full text-xs text-slate-600 break-all px-2 py-2 rounded bg-slate-50 border" data-testid="qr-link-texto">{publicLink}</div>
              <div className="flex gap-2 w-full">
                <button onClick={baixarPng} data-testid="btn-baixar-png" className="flex-1 h-10 rounded-lg bg-brand text-white text-sm font-semibold hover:bg-brand-hover">Baixar PNG</button>
                <button onClick={copiarLink} data-testid="btn-copiar-link" className="flex-1 h-10 rounded-lg bg-white border border-[#D5DEE5] text-navy text-sm font-semibold hover:bg-slate-50">{copiado ? "Copiado" : "Copiar link"}</button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}

      {mostrarSecao && temResumo && (
        <div className="bg-card rounded-2xl border border-black/5 p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] mt-4" data-testid="secao-avaliacoes-treinamento">
          <h3 className="text-base font-bold text-navy mb-3">Avaliações de treinamento ({resumo.total_participantes})</h3>
          {resumo.pct_acerto_teste > 0 && (
            <div className="text-sm text-slate-600 mb-3">% acerto do teste (geral): <strong className="text-navy">{resumo.pct_acerto_teste}%</strong></div>
          )}
          {(resumo.aplicacoes || []).length === 0 && (
            <p className="text-sm text-slate-500 mb-3">Ainda não há treinamentos aplicados com o novo formato — abaixo, respostas antigas.</p>
          )}
          {(resumo.aplicacoes || []).map((ap) => {
            const aberta = respostasAbertas[ap.id];
            return (
              <div key={ap.id} className="border rounded-xl p-3 mb-3" data-testid={`aplicacao-row-${ap.id}`}>
                <div className="flex flex-wrap items-start justify-between gap-2">
                  <div>
                    <div className="font-semibold text-navy">{ap.tema}</div>
                    <div className="text-xs text-slate-500">{dataBR(ap.data)} • Aplicado por {ap.aplicado_por_nome || "—"} {ap.encerrada && <span className="ml-1 text-amber-700">(encerrada)</span>}</div>
                  </div>
                  <div className="flex gap-3 text-sm">
                    <span><span className="text-slate-500">Respostas:</span> <strong className="text-navy">{ap.total_respostas}</strong></span>
                    <span><span className="text-slate-500">Treinamento:</span> <strong className="text-navy">{ap.media_treinamento ?? "—"}</strong></span>
                    <span><span className="text-slate-500">Atendimento:</span> <strong className="text-navy">{ap.media_atendimento ?? "—"}</strong></span>
                  </div>
                </div>
                {ap.total_respostas > 0 && (
                  <button onClick={() => toggleRespostas(ap.id)} data-testid={`btn-ver-respostas-${ap.id}`}
                    className="mt-2 text-xs text-brand font-semibold hover:underline">
                    {aberta ? "Ocultar respostas" : "Ver respostas"}
                  </button>
                )}
                {aberta && aberta.length > 0 && (
                  <div className="mt-2 overflow-x-auto">
                    <table className="w-full text-xs">
                      <thead>
                        <tr className="text-left text-[10px] uppercase tracking-wide text-slate-500 border-b">
                          <th className="py-1 pr-2">Quando</th>
                          <th className="py-1 pr-2">Nome</th>
                          <th className="py-1 pr-2">Setor</th>
                          <th className="py-1 pr-2">Função</th>
                          <th className="py-1 pr-2">Acertos</th>
                          <th className="py-1 pr-2">Trein.</th>
                          <th className="py-1 pr-2">Atend.</th>
                          <th className="py-1 pr-2">Interesse</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aberta.map((r) => {
                          const av = r.avaliacao || {};
                          const treinArr = ["nota_geral", "clareza", "aplicavel", "dominio_instrutor"].map((k) => av[k]).filter((v) => typeof v === "number" && v > 0);
                          const atendArr = ["nota_atendimento_geral", "nota_atendimento_tecnico", "nota_atendimento_vendedor", "nota_atendimento_gerente"].map((k) => av[k]).filter((v) => typeof v === "number" && v > 0);
                          const avgT = treinArr.length ? (treinArr.reduce((a, b) => a + b, 0) / treinArr.length).toFixed(1) : "—";
                          const avgA = atendArr.length ? (atendArr.reduce((a, b) => a + b, 0) / atendArr.length).toFixed(1) : "—";
                          const tema = (r.novo_tema || {}).tema;
                          return (
                            <tr key={r.id} className="border-b last:border-0">
                              <td className="py-1 pr-2 whitespace-nowrap">{(r.criado_em || "").slice(0, 10)}</td>
                              <td className="py-1 pr-2">{(r.identificacao || {}).nome?.trim() ? (r.identificacao || {}).nome : <span className="italic text-slate-500">Anônimo</span>}</td>
                              <td className="py-1 pr-2">{(r.identificacao || {}).setor}</td>
                              <td className="py-1 pr-2">{(r.identificacao || {}).funcao}</td>
                              <td className="py-1 pr-2 tabular-nums">{r.acertos}/{r.total_questoes}</td>
                              <td className="py-1 pr-2 tabular-nums">{avgT}</td>
                              <td className="py-1 pr-2 tabular-nums">{avgA}</td>
                              <td className="py-1 pr-2">{tema && tema.toLowerCase() !== "não" && <span className="inline-flex items-center rounded-full border border-amber-300 bg-amber-50 text-amber-800 text-[10px] px-2 py-0.5 font-semibold">Interesse: {tema}</span>}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}

          {(resumo.legado || []).length > 0 && (
            <div className="border rounded-xl p-3 mt-2 bg-slate-50/50" data-testid="aplicacao-legado">
              <div className="font-semibold text-navy mb-2 text-sm">Respostas antigas (sem treinamento aplicado)</div>
              <div className="overflow-x-auto">
                <table className="w-full text-xs">
                  <thead>
                    <tr className="text-left text-[10px] uppercase tracking-wide text-slate-500 border-b">
                      <th className="py-1 pr-2">Quando</th><th className="py-1 pr-2">Nome</th><th className="py-1 pr-2">Setor</th><th className="py-1 pr-2">Acertos</th><th className="py-1 pr-2">Nota</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(resumo.legado || []).map((r) => (
                      <tr key={r.id} className="border-b last:border-0">
                        <td className="py-1 pr-2 whitespace-nowrap">{(r.criado_em || "").slice(0, 10)}</td>
                        <td className="py-1 pr-2">{r.nome}</td>
                        <td className="py-1 pr-2">{r.setor}</td>
                        <td className="py-1 pr-2 tabular-nums">{r.acertos}/{r.total}</td>
                        <td className="py-1 pr-2 tabular-nums">{r.nota_geral}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
